/**
 * Firefox compatibility test utilities
 */

import { detectBrowser, checkBrowserCompatibility } from "./browserUtils";

/**
 * Run Firefox compatibility tests
 */
export const runFirefoxCompatibilityTests = () => {
  const browser = detectBrowser();
  const compatibility = checkBrowserCompatibility();

  console.log("🔍 Firefox Compatibility Test Results:");
  console.log("Browser:", browser);
  console.log("Compatible:", compatibility.compatible);
  console.log("Issues:", compatibility.issues);

  if (browser === "firefox") {
    console.log("🦊 Firefox-specific tests:");

    // Test secure context
    console.log("Secure context:", window.isSecureContext);

    // Test cookie access
    console.log("Cookie access:", document.cookie.length > 0);

    // Test localStorage
    try {
      localStorage.setItem("test", "value");
      localStorage.removeItem("test");
      console.log("LocalStorage: Working");
    } catch (error) {
      console.log("LocalStorage: Failed", error);
    }

    // Test sessionStorage
    try {
      sessionStorage.setItem("test", "value");
      sessionStorage.removeItem("test");
      console.log("SessionStorage: Working");
    } catch (error) {
      console.log("SessionStorage: Failed", error);
    }

    // Test fetch with credentials
    testFetchWithCredentials();
  }

  return compatibility;
};

/**
 * Test fetch with credentials (important for authentication)
 */
const testFetchWithCredentials = async () => {
  try {
    const response = await fetch(window.location.origin, {
      method: "HEAD",
      credentials: "include",
      mode: "cors",
    });
    console.log("Fetch with credentials: Working", response.status);
  } catch (error) {
    console.log("Fetch with credentials: Failed", error.message);
  }
};

/**
 * Get Firefox troubleshooting steps
 */
export const getFirefoxTroubleshootingSteps = () => {
  return [
    "1. Click the shield icon in the address bar",
    '2. Select "Disable Enhanced Tracking Protection for this site"',
    "3. Refresh the page",
    "4. If issues persist, try these additional steps:",
    "   - Go to Firefox Settings > Privacy & Security",
    '   - Under "Enhanced Tracking Protection", select "Custom"',
    '   - Uncheck "Cookies" or add this site to exceptions',
    "   - Restart Firefox and try again",
  ];
};

